import { render, staticRenderFns } from "./CityTaxiPricingIndex.vue?vue&type=template&id=5863ae0e"
import script from "./CityTaxiPricingIndex.vue?vue&type=script&lang=js"
export * from "./CityTaxiPricingIndex.vue?vue&type=script&lang=js"
import style0 from "./CityTaxiPricingIndex.vue?vue&type=style&index=0&id=5863ae0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports